import { render } from "./EmployeeWallets.vue?vue&type=template&id=5d3a0b5e&scoped=true"
import script from "./EmployeeWallets.vue?vue&type=script&lang=js"
export * from "./EmployeeWallets.vue?vue&type=script&lang=js"

import "./EmployeeWallets.vue?vue&type=style&index=0&id=5d3a0b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3a0b5e"]])

export default __exports__